import { render, staticRenderFns } from "./xuexizliao.vue?vue&type=template&id=82f2f430&scoped=true&"
import script from "./xuexizliao.vue?vue&type=script&lang=js&"
export * from "./xuexizliao.vue?vue&type=script&lang=js&"
import style0 from "./xuexizliao.vue?vue&type=style&index=0&id=82f2f430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f2f430",
  null
  
)

export default component.exports